//---- components ---------
//---- mixins -------------
//---- services -----------
import { ajaxService, httpClient } from '@/app/services';
//---- other --------------
import URL from '../common/URL.js';
//---- 3rd-parties --------

class AdminService {
  getAdminInformation() {
    let promises = [];
    promises.push(httpClient.get('/getSystemInfo.action'));
    promises.push(httpClient.get('/getProjectInfo.action'));
    promises.push(httpClient.get('/getSessionInfo.action'));
    return httpClient.all(promises);
  }
  getProjectInformation() {
    return ajaxService.get('/getProjectInfo.action')
  }
  getSessionInformation() {
    return ajaxService.get('/getSessionInfo.action');
  }
  runIndexing(fromData){
    return ajaxService.postData('/runIndex.action', fromData);
  }
  checkIndexStatus(){
    return ajaxService.get('/checkIndexStatus.action')
  }
  getKPI(params){
    return ajaxService.getWithParams('/getKPI.action', params)
  }
  getKPIs(){
    return ajaxService.get('/getKPIs.action')
  }
  getIndexingStatus() {
    return ajaxService.get('/getLastMilkEvents.action')
  }
  getSolrStatus() {
    return ajaxService.get('/getSolrStatus.action')
  }
  restartSolrServer() {
    return ajaxService.get('/solrServerCtl.action?action=restart')
  }
  startSolrServer() {
    return ajaxService.get('/solrServerCtl.action?action=start')
  }
  stopSolrServer() {
    return ajaxService.get('/solrServerCtl.action?action=stop')
  }
  saveStyles(styles) {
    const reqData = new FormData();
    reqData.append('styles', JSON.stringify(styles));
    return ajaxService.postData(URL.saveStylesUrl, reqData)
  }
  async loadStyles() {
    return (await ajaxService.get(URL.loadStylesUrl))?.data;
  }
  async initStyles() {
    return (await ajaxService.get(URL.initStylesUrl))?.data;
  }
}

export default new AdminService();